import * as t from 'ts-schema';
// Sort schema
export const sortSchema = t.object({
  property: t.string,
  order: t.union(t.literal('ASC'), t.literal('DESC'))
});

// Filter group schema
export const filterGroupSchema = t.object({
  filters: t.array(t.unknown)
});

// Segment schema
export const segmentSchema = t.object({
  _advancedFilterGroups: t.array(filterGroupSchema),
  _pipelinePropertyName: t.optional(t.string),
  quickFilters: t.array(t.unknown),
  quickFilterProperties: t.array(t.object({
    name: t.string
  })),
  search: t.optional(t.string),
  pipelineId: t.optional(t.string),
  sorts: t.array(sortSchema),
  objectTypeId: t.string
});

// ViewDraft schema
export const viewDraftSchema = t.object({
  viewId: t.string,
  segmentHashOrId: t.string,
  vizConfigHashesById: t.record(t.string, t.string),
  vizSettingHashesById: t.record(t.string, t.string),
  viewMetaHash: t.optional(t.string)
});

// Export types for use in the codebase